import { useMemo } from "react";
import { QontactPointCustomFieldsService } from "@services/CollaboratorCustomFieldsService";
import { Application } from "@core/Application";
import CustomFieldsConfigScreen, { CustomFieldsConfigTexts } from "./CustomFieldsConfigScreen";
import { CustomFieldsConfigOptions } from "./CustomFieldsConfigScreenViewModel";

interface ConfiguracionCamposQontactPointScreenProps {
    orgID: string;
}

// Qontact point custom fields settings (ENG-554). Same screen as the collaborator
// custom fields, with its own texts and the "deactivate instead of delete" dialog.
const ConfiguracionCamposQontactPointScreen: React.FC<ConfiguracionCamposQontactPointScreenProps> = ({ orgID }) => {
    const customFieldsService = useMemo(
        () => new QontactPointCustomFieldsService(Application.shared().coreDependencies.httpClient),
        [],
    );

    const options = useMemo<CustomFieldsConfigOptions>(() => ({
        typeExamples: {
            text: "Encargado del edificio".localized(),
            number: "Cantidad de pisos".localized(),
            date: "Fecha de inicio de obra".localized(),
            boolean: "Tiene estacionamiento".localized(),
            list: "Edificio, Obra nueva, Remodelación".localized(),
        },
        loadErrorText: "No se pudieron cargar los campos de Qontact Points".localized(),
        editValueInUseErrorText: "No se pudo actualizar el campo. Si quitaste una opción, puede estar usada en algún Qontact Point.".localized(),
        deleteInUseErrorText: "No se puede eliminar porque algún Qontact Point ya tiene información cargada en este campo. Desactivalo para que no vuelva a mostrarse.".localized(),
        suggestDeactivateOnDeleteInUse: true,
    }), []);

    const texts = useMemo<CustomFieldsConfigTexts>(() => ({
        title: "Campos de Qontact Points".localized(),
        subtitle: "Datos propios que tu organización guarda en cada lugar. Se completan en la pestaña Información del Qontact Point.".localized(),
        loadingText: "Cargando campos de Qontact Points...".localized(),
        emptyText: "No hay campos creados".localized(),
        emptyDescription: "Creá un campo para guardar datos propios de cada lugar, como el encargado del edificio o el tipo de obra.".localized(),
        inactiveHint: "Inactivo: no se muestra en los Qontact Points".localized(),
        requiredDescription: "Si está activo, no se podrá guardar el Qontact Point sin completar este dato.".localized(),
        listValuesDescription: "Agregá las opciones que después se podrán elegir en cada Qontact Point.".localized(),
        namePlaceholder: "Encargado del edificio".localized(),
        listValuePlaceholder: "Ej. Obra nueva".localized(),
        fieldInUseTitle: "Este campo tiene datos cargados".localized(),
        fieldInUseBody: (fieldName: string) =>
            "«%s» ya tiene datos cargados en algunos Qontact Points, por eso no se puede eliminar.".localized(fieldName),
        fieldInUseDeactivateHint: "Te recomendamos desactivarlo: deja de mostrarse en los Qontact Points, pero los datos se conservan y podés volver a activarlo cuando quieras.".localized(),
    }), []);

    return (
        <CustomFieldsConfigScreen
            orgID={orgID}
            customFieldsService={customFieldsService}
            options={options}
            texts={texts}
        />
    );
};

export default ConfiguracionCamposQontactPointScreen;
